import { handleTrack } from '../../../../utils/tracker';

interface IKnowMore {
  href: string;
  funnelMetricLabel: string;
  arrow?: boolean;
  className?: string;
  textClasses?: string;
  hoverEffect?: boolean;
  id?: string;
}

export const KnowMore: React.FC<IKnowMore> = ({
  href,
  funnelMetricLabel,
  arrow = true,
  className = '',
  textClasses = 'font-bold text-base',
  hoverEffect = false,
  id,
}) => {
  return (
    <a
      id={id}
      href={href}
      rel="noreferrer"
      className={`text-blue-350 mx-6 ${
        hoverEffect ? 'hover:text-blue-450 hover:underline' : ''
      } ${textClasses} ${className}`}
      onClick={(e) => handleTrack({ label: funnelMetricLabel, obj: e.target })}
    >
      Know more {arrow ? '→' : ''}
    </a>
  );
};
